import { ListSection } from '@ui-components/global/LayoutStyling'
import { BodyText, LabelText } from '@ui-components/typography/Typography'
import { JSX, ReactElement, useId } from 'react'

export const UnorderedList = ({ label, listItems, ...rest }: { label: string; listItems: string[] }): JSX.Element => {
  const id = useId()

  return (
    <div {...rest}>
      <LabelText id={id}>{label}</LabelText>
      <BodyText>
        <ListSection $listStyleType="disc">
          <ul aria-labelledby={id}>
            {listItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </ListSection>
      </BodyText>
    </div>
  )
}

export const UnorderedChildrenList = (
  props: {
    children: ReactElement[] | ReactElement
  } & ({ label: string; tagName?: 'h3' | 'h4' } | { ariaLabelledBy: string }),
): JSX.Element => {
  let ariaLabelledBy = useId()
  if ('ariaLabelledBy' in props) {
    ariaLabelledBy = props.ariaLabelledBy
  }

  const items = Array.isArray(props.children) ? props.children : [props.children]

  return (
    <div>
      {'label' in props && (
        <LabelText id={ariaLabelledBy} tagName={props.tagName}>
          {props.label}
        </LabelText>
      )}
      <BodyText>
        <ListSection>
          <ul aria-labelledby={ariaLabelledBy}>
            {items.map((child) => (
              <li key={child.key}>{child}</li>
            ))}
          </ul>
        </ListSection>
      </BodyText>
    </div>
  )
}

/**
 * Renders list items coming from single phrase text
 */
export const UnorderedPhraseList = (
  props: {
    children: ReactElement
  } & ({ label: string; tagName?: 'h3' | 'h4' } | { ariaLabelledBy: string }),
): JSX.Element => {
  let ariaLabelledBy = useId()
  if ('ariaLabelledBy' in props) {
    ariaLabelledBy = props.ariaLabelledBy
  }

  return (
    <div>
      {'label' in props && (
        <LabelText id={ariaLabelledBy} tagName={props.tagName}>
          {props.label}
        </LabelText>
      )}
      <BodyText>
        <ListSection>
          <ul aria-labelledby={ariaLabelledBy}>{props.children}</ul>
        </ListSection>
      </BodyText>
    </div>
  )
}
